import axios from "axios";
import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import * as yup from 'yup';

interface IContext {
    serialNumberSchema: any
    saveNewSerialNumber: (values: SerialNumber) => Promise<void>
}

let serialNumberSchema = yup.object({
    serialNumber: yup.string().default('').required("Serial number is mandatory field")
})

type SerialNumber = yup.InferType<typeof serialNumberSchema>;

export let serialNumberContext = React.createContext({} as IContext);

let { Provider } = serialNumberContext;

let SerialNumberProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    let history = useHistory();

    let [isSaving, setSaving] = useState(false);


    let saveNewSerialNumber = async (values: SerialNumber) => {
        try {
            setSaving(true);
            await axios.post('/api/SerialNumbers/SaveNewSerialNumber', values);
            history.push('/serialnumbers');

        } catch (err) {
            setSaving(false);
        }
    }

    return (
        <Provider
            value={{
                serialNumberSchema,
                saveNewSerialNumber
            }}
        >
            {children}
        </Provider>
    )
}

export default SerialNumberProvider;